import { render, staticRenderFns } from "./studentDetail.vue?vue&type=template&id=c79e1d5e&scoped=true"
import script from "./studentDetail.vue?vue&type=script&lang=js"
export * from "./studentDetail.vue?vue&type=script&lang=js"
import style0 from "./studentDetail.vue?vue&type=style&index=0&id=c79e1d5e&prod&lang=less"
import style1 from "./studentDetail.vue?vue&type=style&index=1&id=c79e1d5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79e1d5e",
  null
  
)

export default component.exports